import { Box, Grid, Paper, Typography } from '@mui/material';
import scalapay from '../../../../../assets/img/scalapay.png';
import React, { useContext } from 'react';
import { createReservation } from '../../../../../utils/requests';
import { makeStyles } from 'tss-react/mui';
import { AppContext } from '../../../../../utils/appContext';

const ScalaPayMethod = () => {
  const appContext = useContext(AppContext);

  const useStyles = makeStyles()((theme) => {
    return {
      paymentContainer: {
        textAlign: 'center',
        padding: '3px 0',
        cursor: 'pointer',
        minHeight: 20,
        display: 'flex',
        backgroundColor: '#ffffff',
        border: '1px solid #555',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '4px!important',
        maxHeight: 44,
        '&:hover': {
          borderColor: theme.palette.primary.main
        },
        '& i': {
          fontSize: 30,
          alignItems: 'center',
          display: 'inline-flex'
        },
        '& img': {
          alignItems: 'center',
          display: 'flex'
        }
      }
    };
  });

  const PayWithScalapay = () => {
    appContext.setBackdropIsOpen(true);
    appContext.orders[0].paymentGateway = 'scalapay';
    createReservation(appContext.orders).then((response: any) => {
      window.location.href = response.data.checkoutUrl;
      appContext.setBackdropIsOpen(false);
    });
  };

  const { classes } = useStyles();

  return (
    <>
      <Grid item xs={12} sm={12}>
        <Box>
          <Grid item xs={12}>
            <Paper className={classes.paymentContainer} onClick={() => PayWithScalapay()}>
              <Box pl={1}>
                <Typography component={'p'} variant={'h6'}>
                  <img src={scalapay} height={35} />
                </Typography>
              </Box>
            </Paper>
          </Grid>
        </Box>
      </Grid>
    </>
  );
};

export default ScalaPayMethod;
